export default "__VITE_ASSET__BHNkt4QG__"